import {
  ColumnElement,
  MarketingForgeElementType,
} from "@redotech/redo-model/forge/marketing-signup-forge-types";
import { memo } from "react";
import { Flex } from "../../flex";
import { FormButton } from "./form-button";
import { FormImage } from "./form-image";
import { FormElementProps } from "./index";
import { Input } from "./input";
import { RichText } from "./rich-text";

const elementComponents: Record<
  MarketingForgeElementType,
  React.ComponentType<FormElementProps<any>>
> = {
  [MarketingForgeElementType.INPUT]: Input,
  [MarketingForgeElementType.RICH_TEXT]: RichText,
  [MarketingForgeElementType.BUTTON]: FormButton,
  [MarketingForgeElementType.IMAGE]: FormImage,
  [MarketingForgeElementType.COLUMN]: () => null, // Avoid recursion
};

export const FormColumn = memo(function FormColumn({
  element,
  form,
  brandKit,
  submitting,
  onClose,
}: FormElementProps<ColumnElement>) {
  const getColumnWidth = (index: number): string => {
    if (element.columnWidths && element.columnWidths[index]) {
      return `${element.columnWidths[index]}%`;
    }
    return `${100 / element.totalColumns}%`;
  };

  return (
    <Flex align="stretch" dir="row" justify="space-between" w="full">
      {element.elements.map((childElement, index) => {
        const ElementComponent = elementComponents[childElement.type];
        return (
          <Flex
            dir="column"
            key={index}
            style={{ width: getColumnWidth(index) }}
            w="full"
          >
            <Flex dir="column" flex={1} w="full">
              <ElementComponent
                brandKit={brandKit}
                element={childElement}
                form={form}
                onClose={onClose}
                submitting={submitting}
              />
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
});
